module.exports = __webpack_public_path__ + "453df551ff21ff4b58056678705ffb46.png";